import { reducerWithInitialState } from "typescript-fsa-reducers";
import { deselectCells, selectCell } from "./actions";
import { SelectedCell } from "./types";

export type SelectedCellsState = SelectedCell[];

export default reducerWithInitialState<SelectedCellsState>([])
  .case(deselectCells, _ => [])
  .case(selectCell, (_, selectedCell) => [selectedCell]);



// WEBPACK FOOTER //
// ./src/spread/model/selectedCells/reducer.ts